import { Helmet } from "react-helmet-async";
import { useParams, useSearchParams } from "react-router-dom";
import { AskByEmailWidget } from "@/components/widget/AskByEmailWidget";
import { Button } from "@/components/ui/button";
import { useEmailWidget } from "@/hooks/agent/useEmailWidget";

const EmailWidgetPage = () => {
  const { url_name } = useParams();
  const [params] = useSearchParams();
  const { config, send, close } = useEmailWidget(url_name, params.get("source") || document.referrer || null);
  const embedded = params.get("embed") === "true";

  return (
    <main className={embedded ? "min-h-[100dvh]" : "flex min-h-[100dvh] items-center justify-center bg-genie-background p-4"}>
      <Helmet>
        <title>{config.data ? `Email ${config.data.name}` : "Ask by email"}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className={embedded ? "w-full" : "w-full max-w-md"}>
        {config.isLoading ? (
          <p role="status" className="p-6 text-center text-sm text-gray-600">Getting your Genie ready…</p>
        ) : config.data ? (
          <AskByEmailWidget
            key={url_name}
            genieName={config.data.name}
            branding={config.data.branding}
            urlName={url_name}
            onSubmit={send}
            onClose={embedded && window.parent !== window ? close : undefined}
          />
        ) : (
          <div className="space-y-4 p-6 text-center">
            <p className="text-sm text-gray-600">This Genie isn’t taking email questions right now.</p>
            <Button variant="outline" className="min-h-11" onClick={() => config.refetch()}>Try again</Button>
          </div>
        )}
      </div>
    </main>
  );
};

export default EmailWidgetPage;
